export default __webpack_public_path__ + "static/media/f.3be97a4892afc807608a06133e822688.mp3";